import { combineReducers } from 'redux';
import { SET_REPORTING_SORT, SET_REPORTING_START_DATE, SET_REPORTING_END_DATE,
         I18N_LOADED, RECEIVE_USERNAME, RECEIVE_SHOP_ID, RECEIVE_EXTERNAL_SHOP_ID, RECEIVE_SHOP_NAME,
         RECEIVE_MERCHANT_DASH_ALLOWED, RECEIVE_READ_ONLY_USER,
         RECEIVE_AGGREGATE_PERFORMANCE, RECEIVE_MONTH_TO_DATE_PERFORMANCE,
         SET_DAILY_PERFORMANCE, UPDATE_STRATEGY, SAVE_STRATEGY_SUCCESS,
         SAVE_STRATEGY_FAILED, PAUSE_STRATEGY_SUCCESS, PAUSE_STRATEGY_FAILED,
         RESUME_STRATEGY_SUCCESS, RESUME_STRATEGY_FAILED, RECEIVE_ADVERTISABLE_EID,
         RECEIVE_NOTIFICATIONS, DISMISS_NOTIFICATION, FINISHED_LOADING_NOTIFICATIONS,
         RECEIVE_STRATEGY, FINISHED_LOADING_STRATEGY, RECEIVE_DAILY_ATTRIBUTIONS,
         RECEIVE_AGGREGATE_ATTRIBUTIONS, FETCH_AGGREGATE_PERFORMANCE_FAILED,
         FETCH_MONTH_TO_DATE_PERFORMANCE_FAILED, SHOW_SAVE_MODAL,
         ACTIVATE_MONTHLY_BUDGET_CAP_VALIDATION, FETCH_RECOMMENDED_BUDGET_FAILED,
         RECEIVE_RECOMMENDED_BUDGET, SHOW_RECOMMENDED_BUDGET } from './actions.js';

import _ from 'lodash';

function i18nLoadedReducer(state = false, incomingAction) {
    if (incomingAction.type === I18N_LOADED) {
        return incomingAction.value;
    }
    return state;
}

function usernameReducer(state = null, incomingAction) {
    if (incomingAction.type === RECEIVE_USERNAME) {
        return incomingAction.value;
    }
    return state;
}

function showSaveModalReducer(state = false, incomingAction) {
    if (incomingAction.type === SHOW_SAVE_MODAL) {
        return incomingAction.value;
    }
    return state;
}

function shopIdReducer(state = null, incomingAction) {
    if (incomingAction.type === RECEIVE_SHOP_ID) {
        return incomingAction.value;
    }
    return state;
}

function externalShopIdReducer(state = null, incomingAction) {
    if (incomingAction.type === RECEIVE_EXTERNAL_SHOP_ID) {
        return incomingAction.value;
    }
    return state;
}

function shopNameReducer(state = null, incomingAction) {
    if (incomingAction.type === RECEIVE_SHOP_NAME) {
        return incomingAction.value;
    }
    return state;
}

function merchantDashAllowedReducer(state = null, incomingAction) {
    if (incomingAction.type === RECEIVE_MERCHANT_DASH_ALLOWED) {
        return incomingAction.value;
    }
    return state;
}

function readOnlyUserReducer(state = null, incomingAction) {
    if (incomingAction.type === RECEIVE_READ_ONLY_USER) {
        return incomingAction.value;
    }
    return state;
}

function advertisableEidReducer(state = null, incomingAction) {
    if (incomingAction.type === RECEIVE_ADVERTISABLE_EID) {
        return incomingAction.value;
    }
    return state;
}

function notificationsReducer(state = [], incomingAction) {
    if (incomingAction.type === RECEIVE_NOTIFICATIONS) {
        return incomingAction.value;
    } else if (incomingAction.type === DISMISS_NOTIFICATION) {
        return state.filter(notification => notification.display_order !== incomingAction.displayOrder);
    }
    return state;
}

function strategyReducer(state = null, incomingAction) {
    switch (incomingAction.type) {
        case RECEIVE_STRATEGY:
        case SAVE_STRATEGY_SUCCESS:
        case PAUSE_STRATEGY_SUCCESS:
        case RESUME_STRATEGY_SUCCESS:
            return incomingAction.value;
        case UPDATE_STRATEGY:
            return _.merge({}, state, incomingAction.value,
                {is_dirty: true});
        case SAVE_STRATEGY_FAILED:
            return Object.assign({}, state, {
                ui_state: {
                    save_campaign_failed: true
                }
            });
        case PAUSE_STRATEGY_FAILED:
            return Object.assign({}, state, {
                ui_state: {
                    pause_campaign_failed: true
                }
            });
        case RESUME_STRATEGY_FAILED:
            return Object.assign({}, state, {
                ui_state: {
                    resume_campaign_failed: true
                }
            });
        default:
            return state;
    }
}

function recommendedBudgetReducer(state = null, incomingAction) {
    switch(incomingAction.type) {
        case RECEIVE_RECOMMENDED_BUDGET:
            return incomingAction.value;
        case FETCH_RECOMMENDED_BUDGET_FAILED:
            return Object.assign({}, state, {
                ui_state: {
                    fetch_recommended_budget_failed: true
                }
            });
        default:
            return state;
    }
}

function displayRecommendedBudgetReducer(state = false, incomingAction) {
    switch(incomingAction.type) {
        case SHOW_RECOMMENDED_BUDGET:
            return incomingAction.value;
        default:
            return state;
    }
}

function aggregatePerformanceReducer(state = null, incomingAction) {
    if (incomingAction.type === RECEIVE_AGGREGATE_PERFORMANCE) {
        return incomingAction.value;
    }
    if (incomingAction.type === FETCH_AGGREGATE_PERFORMANCE_FAILED) {
        return Object.assign({}, state, {
            ui_state: {
                fetch_performance_failed: true
            }
        });
    }
    return state;
}

function monthToDatePerformanceReducer(state = null, incomingAction) {
    if (incomingAction.type === RECEIVE_MONTH_TO_DATE_PERFORMANCE) {
        return incomingAction.value;
    }
    if (incomingAction.type === FETCH_MONTH_TO_DATE_PERFORMANCE_FAILED) {
        return Object.assign({}, state, {
            ui_state: {
                fetch_performance_failed: true
            }
        });
    }
    return state;
}

function runMonthlyBudgetCapValidationReducer(state = null, incomingAction) {
    if (incomingAction.type === ACTIVATE_MONTHLY_BUDGET_CAP_VALIDATION) {
        return incomingAction.value;
    }
    return state;
}

function dailyPerformanceReducer(state = null, incomingAction) {
    if (incomingAction.type === SET_DAILY_PERFORMANCE) {
        return incomingAction.value;
    }
    return state;
}

function dailyAttributionsReducer(state = null, incomingAction) {
    if (incomingAction.type === RECEIVE_DAILY_ATTRIBUTIONS) {
        return incomingAction.value;
    }
    return state;
}

function aggregateAttributionsReducer(state = null, incomingAction) {
    if (incomingAction.type === RECEIVE_AGGREGATE_ATTRIBUTIONS) {
        return incomingAction.value;
    }
    return state;
}

function finishedLoadingNotificationsReducer(state = false, incomingAction) {
    if (incomingAction.type === FINISHED_LOADING_NOTIFICATIONS) {
        return true;
    }
    return state;
}

function finishedLoadingStrategyReducer(state = false, incomingAction) {
    if (incomingAction.type === FINISHED_LOADING_STRATEGY) {
        return true;
    }
    return state;
}

function reportingStartDateReducer(state = null, incomingAction) {
    if (incomingAction.type === SET_REPORTING_START_DATE) {
        return incomingAction.value;
    }
    return state;
}

function reportingEndDateReducer(state = null, incomingAction) {
    if (incomingAction.type === SET_REPORTING_END_DATE) {
        return incomingAction.value;
    }
    return state;
}

function reportingSortReducer(state = {direction: 'desc', accessor: (item) => { return item.date.getTime();}, key: 'date'}, incomingAction) {
    if (incomingAction.type === SET_REPORTING_SORT) {
        return incomingAction.value;
    }
    return state;
}

const reducer = combineReducers({
    i18nLoaded: i18nLoadedReducer,
    username: usernameReducer,
    shopId: shopIdReducer,
    externalShopId: externalShopIdReducer,
    shopName: shopNameReducer,
    merchantDashAllowed: merchantDashAllowedReducer,
    isReadOnlyUser: readOnlyUserReducer,
    advertisableEid: advertisableEidReducer,
    notifications: notificationsReducer,
    finishedLoadingNotifications: finishedLoadingNotificationsReducer,
    strategy: strategyReducer,
    finishedLoadingStrategy: finishedLoadingStrategyReducer,
    aggregatePerformance: aggregatePerformanceReducer,
    monthToDatePerformance: monthToDatePerformanceReducer,
    runMonthlyBudgetCapValidation: runMonthlyBudgetCapValidationReducer,
    dailyPerformance: dailyPerformanceReducer,
    reportingStartDate: reportingStartDateReducer,
    reportingEndDate: reportingEndDateReducer,
    reportingSort: reportingSortReducer,
    showSaveModal: showSaveModalReducer,
    dailyAttributions: dailyAttributionsReducer,
    aggregateAttributions: aggregateAttributionsReducer,
    recommendedBudget: recommendedBudgetReducer,
    isRecommendedBudgetDisplayed: displayRecommendedBudgetReducer
});

export default reducer;
